import React, { PropTypes } from 'react'
import classnames from 'classnames'
import CSSModules from 'react-css-modules'

import styles from './button-group.css'

const ButtonGroup = ({ buttons, disabled }) => {
  const hasPrimary = buttons.filter(({ isPrimary }) => isPrimary).length === 1
  return (
    <div styleName={`button-group ${disabled ? 'is-disabled' : ''}`}>
      {buttons.map((button, index) => {
        const isPrimary = hasPrimary ? button.isPrimary : index === 0
        const styleName = classnames({
          'button-first': index === 0,
          'button-has-border': index > 0,
          'button-last': index === buttons.length - 1,
          'button-primary': isPrimary,
          'button-normal': !isPrimary,
        })
        return (
          <button key={index} styleName={styleName} onClick={button.onClick}>
            {button.text}
          </button>
        )
      })}
    </div>
  )
}

ButtonGroup.propTypes = {
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    onClick: PropTypes.func,
  })),
  disabled: PropTypes.bool,
}

export default CSSModules(ButtonGroup, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/button-group/button-group.js
 **/